<template>
    <div>
        <div class="home-search-modal-outer-container position-relative">
            <div class="home-search-modal-container bg-white position-absolute rounded shadow border"
                 :class="{'d-none': hideServiceModal}">

                <div class="home-search-modal">
                    <div class="search-modal-headline d-flex justify-content-between align-items-start">
                        <h6 class="font-weight-bold">
                            Welchen Service benötigst du?
                            <br>
                            <small>(Services in Icons sind bereits vorab kalkulierbar)</small>
                        </h6>
                        <div class="search-modal-exit position-relative" @click="closeServiceModal()">
                            <img src="app/themes/repareo-theme/dist/images/icons/icon-cross.svg" alt="">
                        </div>
                    </div>
                    <div class="search-modal-categories d-flex" style="max-width:510px!important; flex-wrap:wrap!important">
                        <div class="search-modal-category mb-2 d-flex flex-column ml-0 pb-1 border align-items-center rounded ml-0"
                             @click="setService(14)">
                            <img src="app/themes/repareo-theme/dist/images/icons/icon-service-zahnriemenwechsel.svg"
                                 alt="">
                            <span>Zahnriemenwechsel</span>
                        </div>
                        <div class="search-modal-category mb-2 d-flex flex-column pb-1 border align-items-center rounded"
                             @click="setService(15)">
                            <img src="app/themes/repareo-theme/dist/images/icons/icon-service-bremse.svg" alt="">
                            <span>Bremsenwechsel</span>
                        </div>
                        <div class="search-modal-category mb-2 d-flex flex-column pb-1 border align-items-center rounded"
                             @click="setService(12)">
                            <img src="app/themes/repareo-theme/dist/images/icons/icon-service-oelwechsel.svg" alt="">
                            <span>Ölwechsel</span>
                        </div>
                        <div class="search-modal-category mb-2 d-flex flex-column pb-1 border align-items-center rounded mr-0"
                             @click="setService(13)">
                            <img src="app/themes/repareo-theme/dist/images/icons/icon-service-inspektion.svg" alt="">
                            <span>Inspektion</span>
                        </div>
                      <div
                          class="search-modal-category mb-2 d-flex flex-column pb-1 border align-items-center rounded ml-0"
                          @click="setService(1)">
                        <img src="app/themes/repareo-theme/dist/images/icons/icon-service-reifenwechsel.svg" alt="">
                        <span>Räderwechsel</span>
                      </div>
                      <div
                          class="search-modal-category mb-2 d-flex flex-column pb-1 border align-items-center rounded mr-0"
                          @click="setService(7)">
                        <img src="app/themes/repareo-theme/dist/images/icons/icon-service-reifenwechsel.svg" alt="">
                        <span>Reifenmontage</span>
                      </div>
                      <div
                          class="search-modal-category mb-2 d-flex flex-column pb-1 border align-items-center rounded mr-0"
                          @click="setService(132)">
                        <img src="app/themes/repareo-theme/dist/images/icons/icon-service-huau.svg" alt="">
                        <span>HU/AU ("TÜV")</span>
                      </div>
                    </div>
                    <div class="search-modal-searchbar rounded">
                        <div class="position-relative h-100">
                            <input class="h-100 position-relative" type="text" placeholder="Suche nach jedem Service"
                                   v-model="searchFilter">
                            <div class="modal-searchbar-icon position-absolute">
                                <img src="app/themes/repareo-theme/dist/images/icons/icon-search.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="search-modal-service-list-container mt-3">
                        <div data-simplebar id="search-modal-service-list" class="search-modal-service-list border">
                            <div class="input-group d-flex flex-column align-items-center">

                                <div class="service-list-item d-flex align-items-center"
                                     v-for="service in filteredServices" @click="setService(service.id)">
                                    <div class="list-item-radio-container">
                                        <input :id="service.id"
                                               type="radio"
                                               name="service-list-selection"
                                               :aria-label="service.name">
                                    </div>
                                    <label class="mb-0" name="service-list-selection" :for="service.id">
                                        {{ service.name }}
                                    </label>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="home-search-desktop">
            <div class="home-search-fields d-flex bg-white rounded px-0 mx-auto">
                <div class="home-search-field pl-4 flex-grow-1" :class="{'home-search-field-selected': service}"
                     @click="openServiceModal()">
                    <span class="search-field-heading d-block">SERVICE</span>
                    <span class="search-field-example d-block" v-if="!service">Zum Beispiel: Inspektion</span>
                    <span class="search-field-example d-block" v-if="service">{{ service.name }}</span>

                    <beat-loader :loading="services.length === 0" :color="spinner_color"></beat-loader>
                </div>
                <div class="home-search-field pl-4 border-right-0 position-relative flex-grow-1"
                     :class="{'home-search-field-selected': location}">
                    <span class="search-field-heading d-block">PLZ</span>
                    <span class="search-field-example d-inline-block"
                          contenteditable="false"
                          v-if="location && !showLocationFilter"
                          @click="showLocationFilter = true">{{ location.postcode }} {{ location.name }}</span>
                    <input class="search-field-example form-control-plaintext w-100 p-0" v-if="showLocationFilter"
                           placeholder="Wo soll deine Werkstatt sein?" v-model="locationFilter">
                    <beat-loader :loading="locations.length === 0" :color="spinner_color"></beat-loader>
                    <div v-if="foundLocations && locationFilter && showLocationFilter" data-simplebar
                         class="search-results rounded-bottom bg-white border">
                        <div>
                            <div class="search-result" v-for="location in foundLocations"
                                 @click="setLocation(location.postcode)">{{ location.postcode }} {{ location.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="home-search-button-field">
                    <a class="btn btn-primary d-flex align-items-center text-white font-weight-normal"
                       disabled="!service || !location" v-on:click="submit()">
                        <img src="app/themes/repareo-theme/dist/images/icons/icon-search-regular.svg" alt="">
                        <span class="ml-2">
                            Suchen
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div class="home-search-mobile">
            <div class="home-search-fields d-flex flex-column rounded mx-auto">
                <div class="home-search-field rounded shadow mb-3 bg-white justify-content-between align-items-center"
                     :class="{'home-search-field-selected': service}" @click="openServiceModal()">
                    <div class="home-search-field-selection home-search-field-selection"
                         :class="{'home-search-field-selected': service}">
                        <span class="search-field-heading d-block">SERVICE</span>
                        <span class="search-field-example d-block" v-if="!service">Zum Beispiel: Inspektion</span>
                        <span class="search-field-example d-block" v-if="service">{{ service.name }}</span>
                        <beat-loader :loading="services.length === 0" :color="spinner_color"></beat-loader>
                    </div>
                    <div class="home-search-button-field">
                        <a class="btn btn-primary d-flex align-items-center text-white font-weight-normal"
                           :disabled="!service || !location" v-on:click="submit()">
                            <img src="app/themes/repareo-theme/dist/images/icons/icon-search-regular.svg" alt="">
                            <span class="ml-2">
                                Suchen
                            </span>
                        </a>
                    </div>

                </div>

                <div class="home-search-field rounded shadow bg-white justify-content-between align-items-center"
                     :class="{'home-search-field-selected': location}">
                    <div class="home-search-field-selection" :class="{'home-search-field-selected': location}">
                        <span class="search-field-heading d-block">PLZ</span>

                        <span class="search-field-example" v-if="location && !showLocationFilter"
                              @click="showLocationFilter = true">{{ location.postcode }} {{ location.name }}</span>
                        <input class="search-field-example form-control-plaintext w-100 p-0" v-if="showLocationFilter"
                               placeholder="Wo soll deine Werkstatt sein?" v-model="locationFilter">
                        <div v-if="foundLocations && locationFilter && showLocationFilter" data-simplebar
                             class="search-results rounded-bottom bg-white border">
                            <div>
                                <div class="search-result" v-for="location in foundLocations"
                                     @click="setLocation(location.postcode)">{{ location.postcode }} {{ location.name }}
                                </div>
                            </div>
                        </div>
                        <!-- need to prevent the span from making line breaks -->
                    </div>

                    <div class="home-search-button-field">
                        <a class="btn btn-primary d-flex align-items-center text-white font-weight-normal"
                           :disabled="!service || !location" v-on:click="submit()">
                            <img src="app/themes/repareo-theme/dist/images/icons/icon-search-regular.svg" alt="">
                            <span class="ml-2">
                                Suchen
                            </span>
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "unfetch/polyfill";
import BeatLoader from 'vue-spinner/src/BeatLoader';

export default {
  name: "FrontPageSearch",
  data: () => {
    return {
      hideServiceModal: true,
      service: null,
      location: null,
      services: [],
      locations: [],
      searchFilter: '',
      locationFilter: '',
                validated: false,
                showLocationFilter: true,
                spinner_color: '#2588d9'
            }
        },
        components: {
            BeatLoader,
        },
        methods: {
            handlePostcodeInput: function (e) {
                this.locationFilter = e.target.innerHTML;
            },
            openServiceModal: function () {
                if (this.services.length === 0) {
                    return;
                }
                this.hideServiceModal = false;
            },
            closeServiceModal: function () {
                this.hideServiceModal = true;
            },
            setService: function (serviceId) {
                this.service = this.services.find(service => service.id === serviceId);
                this.closeServiceModal();
            },
            setLocation: function (postcode) {
                this.location = this.locations.find(location => location.postcode === postcode);
                this.showLocationFilter = false;
            },
            submit: function () {
                if (!this.service || !this.location) {
                    return;
                }

                let url = garage_search_url;

              switch (this.service.id) {
                case 1: // wheelchange
                  window.location = url + `/lp/reifenwechsel-3?location=${this.location.slug}`;
                  break;
                case 7: // tire mounting
                  window.location = url + `/termin/werkstaetten?service=2&location=${this.location.postcode}`; //`/werkstaetten-2/reifenmontage/${this.location.slug}`;
                  break;
                case 14: // timingbelt
                  window.location = url + `/zahnriemenwechsel/?location=${this.location.postcode}`;
                  break;
                case 15: // brakes
                  window.location = url + `/bremsenwechsel/?location=${this.location.postcode}`;
                  break;
                case 12: // oilchange
                  // window.location = url + `/#/oelwechsel/?location=${this.location.slug}`;
                  window.location = url + `/oelwechsel/?location=${this.location.postcode}`;
                  break;
                case 13: // inspection
                  window.location = url + `/inspektion/?location=${this.location.postcode}`;
                  break;
                case 56: // trailer coupling
                  window.location = url + `/termin/werkstaetten?service=2&location=${this.location.postcode}`;
                  break;
                case 118: // clutch
                  window.location = url + `/kupplung/?location=${this.location.postcode}`;
                  break;
                case 78: // timing chain
                  window.location = url + `/termin/werkstaetten?service=2&location=${this.location.postcode}`;
                  break;
                case 132: // certificate
                  window.location = url + `/hu-au-tuev/werkstaetten?service=132&location=${this.location.postcode}`;//`/lp/hu-au-tuev-2?location=${this.location.slug}`;
                  break;
                default:
                  window.location = url + `/termin/werkstaetten?service=2&location=${this.location.postcode}`;
              }

            }
        },
        async created() {
            this.services
                = await fetch('/wp-json/garage-services/v1/garage-services')
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    return json;
                });

            this.locations
                = await fetch('/wp-json/garage-services/v1/locations')
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    return json;
                });
        },
        computed: {
            filteredServices: function () {
                return this.services.filter(service => service.name.toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1);
            },
            foundLocations: function () {
                if (this.locationFilter.length < 3) {
                    return [];
                }
                return this.locations.filter(location => location.postcode.startsWith(this.locationFilter));
            }
        }
    }
</script>